import { render, staticRenderFns } from "./PublicUrl.vue?vue&type=template&id=4bc003ba&"
import script from "./PublicUrl.vue?vue&type=script&lang=js&"
export * from "./PublicUrl.vue?vue&type=script&lang=js&"
import style0 from "./PublicUrl.vue?vue&type=style&index=0&id=4bc003ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports